export default {
  forms: [],
  single_form: null,
};
